import { Box } from '@mui/joy';

// The row layer shared by both virtualized recipe grids: the window-scrolled
// one on the recipes page (RecipeGrid) and the container-scrolled one in the
// meal-plan add modal (RecipePickerList). They need different virtualizer
// hooks -- window scrolling and element scrolling are not interchangeable in
// @tanstack/react-virtual -- so each owns its virtualizer and passes it in
// here, but the rows they draw are identical.
export function VirtualRecipeRows({ virtualizer, rows, columns, gap, card, isMobile, scrollMargin = 0 }) {
  return (
    <Box
      sx={{
        height: virtualizer.getTotalSize(),
        width: '100%',
        position: 'relative',
      }}
    >
      {virtualizer.getVirtualItems().map((virtualRow) => (
        <Box
          key={virtualRow.key}
          data-index={virtualRow.index}
          ref={virtualizer.measureElement}
          // The offset goes through `style`, not `sx`: it changes on every
          // scroll frame and emotion would serialize a new class for each
          // distinct value.
          style={{ transform: `translateY(${virtualRow.start - scrollMargin}px)` }}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gridAutoRows: '1fr',
            alignItems: 'stretch',
            gap: `${gap}px`,
            pb: `${gap}px`,
          }}
        >
          {rows[virtualRow.index].map((recipe) => (
            <Box key={recipe.id} sx={{ minWidth: 0, display: 'flex' }}>
              {card(recipe, isMobile)}
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}
